export default "__VITE_ASSET__DO3RcR0V__"